import { Link } from "react-router-dom";
import ServiceLayout, { ContentSection } from "@/components/site/ServiceLayout";
import { Reveal, TickList } from "@/components/site/Reveal";

const SUPPORT = [
  "PTSD and complex trauma",
  "Adjustment to civilian life",
  "Moral injury",
  "Anxiety and depression",
  "Relationship and family difficulties",
  "Anger and emotional regulation",
  "Grief and loss",
  "Injury, discharge and loss of identity",
  "Supporting a partner with service-related mental health difficulties",
  "Parenting within defence families",
];

const ACCESS = [
  {
    q: "Who can access this service?",
    a: "Current and former ADF members, veterans, partners and defence family members. You do not need a formal diagnosis to reach out.",
  },
  {
    q: "Do you accept Open Arms referrals?",
    a: "Yes — Open Arms and veteran-related referrals are accepted where applicable. We can also work alongside DVA arrangements where eligible.",
  },
  {
    q: "Is telehealth available?",
    a: "Yes. Telehealth appointments are available across Australia, and in-home visits are offered across the Gold Coast, Logan and Brisbane.",
  },
  {
    q: "Do I need a GP referral?",
    a: "Not always. A GP referral with a Mental Health Treatment Plan allows Medicare rebates; Open Arms and DVA pathways have their own referral processes. Contact us and we will work out the simplest route for you.",
  },
  {
    q: "Will there be out-of-pocket costs?",
    a: "This depends on your funding arrangement. Many veteran pathways are fully covered. We will always confirm any costs before your first appointment.",
  },
];

export default function VeteransDefence() {
  return (
    <ServiceLayout
      eyebrow="Services"
      title="Support that understands the impact of service"
      lead="Eucalypt Therapy provides trauma-informed mental health support to current and former ADF members, veterans, partners and defence families."
      image="/images/veterans.jpg"
      imageAlt="Silhouette of a soldier memorial at dusk by the sea"
    >
      <ContentSection eyebrow="What we support" title="Support for service-related experiences">
        <TickList items={SUPPORT} />
      </ContentSection>

      <ContentSection eyebrow="Access & funding" title="Clear answers before you commit" pale>
        <div className="max-w-3xl space-y-4">
          {ACCESS.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.05}>
              <div className="rounded-2xl border border-euca-line bg-white p-6 sm:p-7" data-testid={`veteran-access-${i}`}>
                <h3 className="font-serif text-xl font-medium text-euca-dark">{item.q}</h3>
                <p className="mt-2 text-base leading-relaxed text-mutedsoft">{item.a}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-3xl text-base leading-relaxed text-mutedsoft">
            For 24/7 veteran crisis support, contact{" "}
            <span className="font-semibold text-charcoal">Open Arms on 1800 011 046</span>. To enquire about an
            appointment,{" "}
            <Link to="/contact?service=Veterans%20and%20Defence%20Families" className="font-semibold text-euca hover:underline" data-testid="veteran-enquiry-link">
              send an enquiry
            </Link>{" "}
            or call 0417 508 502.
          </p>
        </Reveal>
      </ContentSection>
    </ServiceLayout>
  );
}
